import ExpertTipEditing from './expert-tip-editing';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
class ExpertTipUI extends Plugin {
    init() { }
}
export default class ExpertTip extends Plugin {
    static get requires() {
        return [ExpertTipEditing, ExpertTipUI];
    }
}
